/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface ContactSiegeSocialSearchDto
 */
export interface ContactSiegeSocialSearchDto {
    /**
     * 
     * @type {number}
     * @memberof ContactSiegeSocialSearchDto
     */
    idcontact?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ContactSiegeSocialSearchDto
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof ContactSiegeSocialSearchDto
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof ContactSiegeSocialSearchDto
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ContactSiegeSocialSearchDto
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof ContactSiegeSocialSearchDto
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof ContactSiegeSocialSearchDto
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the ContactSiegeSocialSearchDto interface.
 */
export function instanceOfContactSiegeSocialSearchDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ContactSiegeSocialSearchDtoFromJSON(json: any): ContactSiegeSocialSearchDto {
    return ContactSiegeSocialSearchDtoFromJSONTyped(json, false);
}

export function ContactSiegeSocialSearchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactSiegeSocialSearchDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idcontact': !exists(json, 'idcontact') ? undefined : json['idcontact'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function ContactSiegeSocialSearchDtoToJSON(value?: ContactSiegeSocialSearchDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idcontact': value.idcontact,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

